@if(label()){
	<span>{{label()}}</span>
}
<ng-content/>
<mat-divider class="divider-outline-variant"/>